import { useMutation, useQueryClient } from "@tanstack/react-query";
import { uploadCodeListFile, UploadCodeListFileParams } from "Infrastructure/Api/ApiCustom";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { CODELIST_FILES_QUERY_KEY } from "../Queries/useCodeListFilesQuery";

export function useUploadFileMutation() {
	const queryClient = useQueryClient();
	const showSnackbar = useSnackbar();

	return useMutation({
		mutationFn: (params: UploadCodeListFileParams) => uploadCodeListFile(params),
		onSuccess: () => {
			showSnackbar("Soubor byl úspěšně nahrán", "success");
			queryClient.invalidateQueries({ queryKey: [CODELIST_FILES_QUERY_KEY] });
		},
		onError: (error: Error) => {
			showSnackbar(error.message || "Chyba při nahrávání souboru", "error");
		},
	});
}
